var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"id":"payment-form"}},[_c('div',{attrs:{"id":"payment-element"}}),_c('button',{staticClass:"btn btn-primary mt-1",on:{"click":_vm.addPaymentMethod}},[_vm._v(" Add Payment Method ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }